import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['child', 'parent']

  toggleChildren() {
    const isChecked = this.parentTarget.checked
    this.childTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
  }

  toggleParent() {
    this.parentTarget.checked = this.childTargets.every(
      checkbox => checkbox.checked
    )
  }
}
